export const pageControlValues = ["tasks", "openings"] as const;

export type PageControlValue = (typeof pageControlValues)[number];

export const DEFAULT_PAGE_CONTROL_VALUE: PageControlValue = "tasks";

export function isPageControlValue(
  value: unknown,
): value is PageControlValue {
  return pageControlValues.some(
    (pageControlValue) => pageControlValue === value,
  );
}
